module.exports = __webpack_public_path__ + "img/m_8.f241cfb1.png";